<template>
    <lr-dialog
        :dialogTitle="dialogTitle"
        :dialogVisible.sync="dialogVisible"
        :width="width"
        :destroyOnClose="true"
        @cancel="cancel"
        @diaLogSubmit="diaLogSubmit"
    >
        <div class="container">
            <div class="container-middle">
                <lr-crud
                    ref="crud"
                    @loadData="loadData"
                    :tableData="tableData"
                    :options="tableOptions"
                    :pages="pages"
                    @select="select"
                    @selectAll="select"
                >
                    <template #headerBtnLeft>
                        <el-button @click="addRoles" type="primary">选择部门</el-button>
                    </template>
                </lr-crud>
            </div>
            <div class="container-right">
                <lr-crud
                    ref="checkedCrud"
                    :tableData="checkedCrudData"
                    :options="checkedCrudOptions"
                    @select="removeSelect"
                    @selectAll="removeSelect"
                >
                    <template #headerBtnLeft>
                        <el-button @click="removeRoles" type="primary">移除部门</el-button>
                    </template>
                </lr-crud>
            </div>
        </div>
        
    </lr-dialog>
</template>

<script>
import {
  getWebSiteDeptTree,
} from "@/api/organization";
import {unique} from '@/utils/index.js'
import {
  getList,
} from "@/areas/systemmanage/api/organization";
export default {
  name: "AddDetps",
  components:{
  },
  props:{
    currentWebSiteID:{
        type:String,
        default:'',
    }
  },
  mounted() {
  },
  data() {
    return {
      dialogVisible:true,
      dialogTitle:'添加列表',
      width:'1000px',
      checkedCrudData:[],
      checkedCrudOptions:{
          rowKey: "ID",
        selection:true,
        queryBtn:false,
        treeProps:{children:'qwe'},
        column: [
          { label: "部门名称", field: "Name"},
        ],
        height: "auto",
        pagination:false,
      },
      tableData:[],
      tableOptions: {
        rowKey: "ID",
        treeProps:{ children: 'children', hasChildren: 'HasChild' },
        selection:true,
        index:true,
        queryBtn:false,
        loading:false,
        autoQuery:true,
        advanceSearchDefaultColsVisiable:false,
        column: [
          { label: "部门名称", field: "Name"},
        //   { label: "站点名称", field: "WebSiteName"},
          { label: "排序",field: "Sort"},
          { label: "备注", field: "Remark" },
        ],
        height: "auto",
        pagination:false,
      },
      pages: {
        PageIndex: 1,
        PageSize: 10,
        total: 0,
      },
      treeObj:'',
      checkedData:[],
      removeData:[],
      DeptID:'',
    };
  },
  methods: {
    removeRoles(){
        if(this.removeData.length==0){
            this.$warningMessage("请选择需要移除的部门");
        }else{
            this.removeData.map((item,index)=>{
                this.checkedCrudData.map((j,k)=>{
                    if(j.ID==item.ID){
                        this.checkedCrudData.splice(k,1)
                    }
                })
            })
        }
        this.removeData = [];
        this.$refs.checkedCrud.clearSelection()
    },
    addRoles(){
        if(this.checkedData.length==0){
            this.$warningMessage("请选择需要增加的部门");
        }else{
            let newArr = [...this.checkedData,...this.checkedCrudData]
            let arr3 = unique(newArr)
            // let newArr = [...this.checkedData,...this.checkedCrudData]
            // let arr3 = Array.from(new Set(newArr)) 
            this.checkedCrudData = arr3;
        }
        this.checkedData = [];
        this.$refs.crud.clearSelection()
    },
    removeSelect(selectData,row){
        this.removeData = selectData;
    },
    select(selectData,row){
        this.checkedData = selectData;
    },
    cancel(){
      this.$emit('closeCallback')
    },
    websiteClick(value) {
      this.treeObj = value
      this.$refs.crud.loadData();
    },
    loadData(form){
        getWebSiteDeptTree({WebsiteID:this.currentWebSiteID}).then((res) => {
             if (res.Code === 200) {
                if(res.Data){
                    this.tableData = res.Data;
                   // this.pages.total = res.Data.total;
                    this.$refs.crud.setCurrentRow()
                }
            } else {
                this.tableData  = [];
            }
            this.tableOptions.loading = false;
        });
        //  getList(form).then((res) => {
            // if (res.Code === 200) {
            //     if(res.Data){
            //         this.tableData = res.Data;
            //        // this.pages.total = res.Data.total;
            //         this.$refs.crud.setCurrentRow()
            //     }
            // } else {
            //     this.tableData  = [];
            // }
            this.tableOptions.loading = false;
        // })
    },
    diaLogSubmit(){
        this.$emit('submit',this.checkedCrudData)
    }
  },
};
</script>
<style scoped  lang="scss">
.container{
    height:400px;
    overflow: auto;
    width:100%;
    display: flex;
    >div{
        border: 1px solid #d0d0d0;
        padding: 10px;
    }
    &-left{
        border-right:0!important;
    }
    &-middle{
        width:700px;
        border-right:0!important;
    }
    &-right{
        width: 0;
    flex: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/document/components/AddDepts.vue